const normalizeThreadAutomationActive = (thread = {}) => {
  return thread?.automationActive === true || thread?.automation_active === true;
};

export default normalizeThreadAutomationActive;
